import { useContext } from 'react';
import LoaderContext, { LoaderContextProps } from '@src/v3/contexts/loader';

const useLoader = (): LoaderContextProps => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return context;
};

export default useLoader;
